import { cn as e } from "../../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { cva as i } from "class-variance-authority";
import { Progress as a } from "@base-ui/react/progress";
//#region src/loader/primitive/index.tsx
var o = 48, s = i("relative inline-flex items-center justify-center", {
	variants: {
		size: {
			xs: "size-3 [--circ-loader-radius:16] [--circ-loader-circ:100.531] [--circ-loader-arc:30.1593]",
			sm: "size-4 [--circ-loader-radius:18] [--circ-loader-circ:113.097] [--circ-loader-arc:33.9291]",
			md: "size-5 [--circ-loader-radius:19.2] [--circ-loader-circ:120.637] [--circ-loader-arc:36.191]",
			lg: "size-6 [--circ-loader-radius:20] [--circ-loader-circ:125.664] [--circ-loader-arc:37.6991]",
			xl: "size-8 [--circ-loader-radius:21] [--circ-loader-circ:131.947] [--circ-loader-arc:39.5841]"
		},
		color: {
			primary: "text-icon-accent",
			white: "text-icon-on",
			destructive: "text-icon-error",
			secondary: "text-icon-secondary"
		}
	},
	defaultVariants: {
		size: "md",
		color: "primary"
	}
}), c = t(({ className: t, size: r, color: i, value: c, max: l, style: u, children: d, ...f }, p) => {
	let m = c == null ? void 0 : l ?? 100, h = c != null && m != null && m > 0, g = h ? Math.min(Math.max(c, 0), m) : 0, _ = h ? g : c, v = h ? g / m : 0;
	return /* @__PURE__ */ n(a.Root, {
		ref: p,
		className: e(s({
			size: r,
			color: i
		}), t),
		value: _,
		max: m,
		style: {
			"--circ-loader-progress": v,
			...u
		},
		...f,
		render: /* @__PURE__ */ n("svg", {
			viewBox: `0 0 ${o} ${o}`,
			children: d
		})
	});
}), l = t(({ className: t, children: i, ...s }, c) => /* @__PURE__ */ n(a.Track, {
	ref: c,
	...s,
	render: /* @__PURE__ */ r("g", { children: [/* @__PURE__ */ n("circle", {
		className: e("fill-none stroke-(--color-bg-secondary) stroke-2 [r:var(--circ-loader-radius,22)] [vector-effect:non-scaling-stroke]", t),
		cx: o / 2,
		cy: o / 2
	}), i] })
})), u = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(a.Indicator, {
	ref: i,
	className: e("transition-base origin-center -rotate-90 fill-none stroke-current stroke-2 transition-[stroke-dashoffset,stroke] [r:var(--circ-loader-radius,22)] [stroke-dasharray:var(--circ-loader-circ)] [stroke-dashoffset:calc(var(--circ-loader-circ)*(1-var(--circ-loader-progress,0)))] [vector-effect:non-scaling-stroke] data-indeterminate:animate-[components-loader-spin_1s_linear_infinite] data-indeterminate:[stroke-dasharray:var(--circ-loader-arc)_var(--circ-loader-circ)]", t),
	...r,
	render: /* @__PURE__ */ n("circle", {
		cx: o / 2,
		cy: o / 2,
		strokeLinecap: "round"
	})
}));
c.displayName = a.Root.displayName, l.displayName = a.Track.displayName, u.displayName = a.Indicator.displayName;
var d = {
	Root: c,
	Track: l,
	Indicator: u
};
//#endregion
export { d as LoaderPrimitive };
